export default __webpack_public_path__ + "static/media/VKey2.b82e8e52.svg";